import { CardTable } from 'components/datatable/NewTable'
import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { getDate } from 'utils/DateUtil'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { useDispatch } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import { useParams } from 'react-router'
import { Grid } from '@mui/material'
import { Search } from '@mui/icons-material'
import { getYear } from 'date-fns'
import { darkBlue } from 'utils/constants/ColorTheme'

const EntityPanel = ({ managementEntities = [] }) => {
    const dispatch = useDispatch()
    const { annee, idCollectivite } = useParams()
    const [entities, setEntities] = useState(managementEntities)

    useEffect(() => {
        setEntities(managementEntities)
    }, [managementEntities])

    const handleSearch = (e) => {
        const value = e.target.value
        const serachEntities = managementEntities.filter((entity) => entity.name.startsWith(value)) ?? []
        setEntities(serachEntities)
    }

    const rowsFormated = entities?.length ? entities.map((entity) => {
        const currentEntity = entity?.[getYear(entity?.dateEnd)]
        const dateStart = getDate(entity.dateStart)
        const dateEnd = getDate(entity.dateEnd)
        // TODO: handle alert icons
        return {
            ...entity, dateEnd, dateStart,
            status: currentEntity?.status ? i18n[currentEntity?.status?.name] : i18n.unknown,
            alert: <AccessTimeIcon/>,
        }
    }) : []

    return (
        <CardTable
            title={i18n.managementEntities}
            headers={['siren', 'name', 'dateStart', 'dateEnd', 'status', 'alert']}
            rows={rowsFormated}
            onClickRow={(entity) => dispatch(push(`/rpqs/${annee}/collectivite/${idCollectivite}/eg/${entity.id}/dashboard`))}
            color={darkBlue}
            actions={[
                // Search input
                <Grid
                    container
                    key={'search'}
                    sx={{ position: 'relative', height: '36px' }}
                    py={'4px'}
                    direction={'column'}
                    justifyContent={'center'}
                >
                    <input
                        placeholder={i18n.search}
                        className='no-margin'
                        onChange={handleSearch}
                    />
                    <Search
                        sx={{ position: 'absolute', right: 4 }}
                    />
                </Grid>,
                {
                    icon: 'download',
                    onClick: () => {},
                    tooltip: i18n.download,
                    color: 'white',
                },
            ]}
        />
    )
}

EntityPanel.propTypes = {
    managementEntities: PropTypes.arrayOf(PropTypes.shape({})),
}

export default EntityPanel